import React from 'react';
import Hero from '../components/Hero';
import { Box, Container, Typography } from '@mui/material';

const Home = (props) => {
  return (
    <>
      <Hero />
      <Box component="footer" sx={{ py: 3, textAlign: 'center' }}>
        <Container maxWidth="md"><Typography variant='body2' color="text.secondary">
          This project was sponsored by Lytton Center
        </Typography></Container>
      </Box>
    </>
  );
};

export default Home;
